// extracted by mini-css-extract-plugin
export default {"container":"sign-in-page_container__OEyWk","left_column":"sign-in-page_left_column__+sIVq","right_column":"sign-in-page_right_column__-E3g3","form":"sign-in-page_form__DYcIP"};